export var PAGE_NAME = {
    ERROR: "error",
    EDIT_PROFILE: "edit",
    SHOW_PROFILE: "view",
};
export var DEFAULTS = {
    SUB_FUNCTION: "",
    PAGE_FUNCTION: "",
    PAGE_NAME: "",
    SITE_IDENTIFIER: "vista",
    DEVICE: "<mobi/desk/tab>",
    PNL: "vista",
    CUSTOMER_TYPE: "consumer",
    PRODUCT: "generic",
    ERROR_MESSAGE: "",
    MESSAGE: "",
    PAGE_KIND: "",
};
export var PAGE_SUBFUNCTION = {
    ERROR: "error",
};
